var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-phone-number-input',{attrs:{"default-country-code":"SE","dark":_vm.darkmode,"only-countries":['SE']},on:{"update":_vm.phoneValidation},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})}
var staticRenderFns = []

export { render, staticRenderFns }